import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Chip from '@mui/material/Chip';
import { CheckmarkCircle01Icon, ThumbsDownIcon, ThumbsUpIcon } from 'hugeicons-react';
import { Stack, useTheme } from '@mui/material';
export default function AuditCardChip(_a) {
    var label = _a.label;
    var theme = useTheme();
    return (_jsxs(Stack, { flexDirection: 'row', gap: 1, children: [_jsx(Chip, { size: 'small', variant: 'soft', label: label[1], color: 'success', sx: {
                    '& .MuiChip-label': {
                        fontSize: '13px',
                        fontWeight: 600,
                        color: theme.palette.text.secondary,
                        padding: '10px'
                    }
                }, icon: _jsx(CheckmarkCircle01Icon, { height: '18px', width: '18px', color: theme.palette.text.secondary, style: {
                        stroke: theme.palette.text.secondary
                    } }) }), _jsx(Chip, { size: 'small', variant: 'soft', color: 'primary', label: label[0], sx: {
                    '& .MuiChip-label': {
                        fontSize: '13px',
                        fontWeight: 600,
                        color: theme.palette.text.secondary,
                        padding: '10px'
                    }
                }, icon: _jsx(ThumbsUpIcon, { height: '18px', width: '18px', color: theme.palette.text.secondary, style: {
                        stroke: theme.palette.text.secondary
                    } }) }), _jsx(Chip, { size: 'small', variant: 'soft', label: label[1], color: 'error', sx: {
                    '& .MuiChip-label': {
                        fontSize: '13px',
                        fontWeight: 600,
                        color: theme.palette.text.secondary,
                        padding: '10px'
                    }
                }, icon: _jsx(ThumbsDownIcon, { height: '18px', width: '18px', color: theme.palette.text.secondary, style: {
                        stroke: theme.palette.text.secondary
                    } }) })] }));
}
